@file:Suppress("MagicNumber")

package com.nonopn.skydome.common.app.pages.certnsg

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.pages.probes.BLOCK_NSG_PDF_DURING_TRIAL
import com.nonopn.skydome.common.app.pages.probes.NsgProbePromo
import com.nonopn.skydome.common.app.pages.probes.PdfBlockedNotice
import com.nonopn.skydome.common.app.pages.probes.rememberProbeAccess
import com.nonopn.skydome.common.app.pages.probes.openProbeCreation
import com.nonopn.skydome.common.app.pages.probes.rememberProbeCreationVisible
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryItem
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryType
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skydome.common.app.pages.pdf.PdfHtmlBuilder
import com.nonopn.skydome.common.app.pages.pdf.PdfLangPickerDialog
import com.nonopn.skydome.common.app.pages.pdf.PdfOutputLang
import com.nonopn.skywatcher.maps.LatLng
import com.nonopn.skywatcher.maps.MapUtils
import com.nonopn.skywatcher.maps.providers.GoogleProvider
import com.nonopn.skydome.common.app.pages.fullscreenmap.FullscreenMapContainer
import com.nonopn.skydome.common.app.pages.fullscreenmap.MapZoomControls
import ovh.plrapps.mapcompose.api.addLayer
import ovh.plrapps.mapcompose.api.addMarker
import ovh.plrapps.mapcompose.api.addPath
import ovh.plrapps.mapcompose.api.scale
import ovh.plrapps.mapcompose.api.snapScrollTo
import ovh.plrapps.mapcompose.core.TileStreamProvider
import ovh.plrapps.mapcompose.ui.MapUI
import ovh.plrapps.mapcompose.ui.state.MapState
import com.nonopn.skydome.common.app.pages.sharing.ShareButton
import com.nonopn.skydome.common.app.pages.sharing.ShareManager
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.doc_export_pdf
import com.nonopn.skywatcher.common.app.res.doc_nsg_unit
import com.nonopn.skywatcher.design.utils.localized
import org.jetbrains.compose.resources.stringResource
import com.nonopn.skywatcher.common.app.res.cert_nsg_density_title
import com.nonopn.skywatcher.common.app.res.cert_nsg_measured_network
import com.nonopn.skywatcher.common.app.res.cert_nsg_share_title
import com.nonopn.skywatcher.common.app.res.cert_nsg_notable_activity_title
import com.nonopn.skywatcher.common.app.res.cert_nsg_period_suffix
import com.nonopn.skywatcher.common.app.res.cert_nsg_notable_values
import com.nonopn.skywatcher.common.app.res.cert_nsg_zone_0_1km
import com.nonopn.skywatcher.common.app.res.cert_nsg_zone_1_2km
import com.nonopn.skywatcher.common.app.res.cert_nsg_no_notable_impacts
import com.nonopn.skywatcher.common.app.res.cert_nsg_methodology
import com.nonopn.skywatcher.common.app.res.cert_nsg_vs_ng
import com.nonopn.skywatcher.common.app.res.cert_nsg_vs_ng_title
import com.nonopn.skywatcher.common.app.res.cert_nsg_standards_title
import com.nonopn.skywatcher.common.app.res.cert_nsg_standards_text
import com.nonopn.skywatcher.common.app.res.cert_nsg_measured_label
import com.nonopn.skywatcher.common.app.res.cert_nsg_zone_network
import com.nonopn.skywatcher.common.app.res.cert_nsg_density_section
import com.nonopn.skywatcher.common.app.res.cert_nsg_comparison_section
import com.nonopn.skywatcher.common.app.res.cert_nsg_detected_impacts
import com.nonopn.skywatcher.common.app.res.cert_nsg_median_intensity
import com.nonopn.skywatcher.common.app.res.cert_nsg_avg_intensity
import com.nonopn.skywatcher.common.app.res.cert_nsg_max_intensity
import com.nonopn.skywatcher.common.app.res.cert_nsg_avg_sensors
import com.nonopn.skywatcher.common.app.res.cert_nsg_level_low
import com.nonopn.skywatcher.common.app.res.cert_nsg_level_moderate
import com.nonopn.skywatcher.common.app.res.cert_nsg_your_site
import com.nonopn.skywatcher.common.app.res.cert_nsg_level_high
import com.nonopn.skywatcher.common.app.res.cert_nsg_location_label

import com.nonopn.skydome.common.app.utils.fmt
import korlibs.time.DateTime

import kotlin.math.PI
import kotlin.math.cos


private const val MAP_LEVEL_COUNT = 18
private val MAP_FULL_SIZE = 256 shl MAP_LEVEL_COUNT

private object Colors {
    val Primary = Color(0xFF2B7FE0)
    val Background = Color(0xFFF5F7FA)
    val Surface = Color.White
    val Heading = Color(0xFF1A2B4A)
    val Muted = Color(0xFF6B7A99)
    val Subtle = Color(0xFF9BA3B2)
    val Divider = Color(0xFFEEF2F8)
    val OnPrimary = Color.White
    val GreenLow = Color(0xFF4CAF50)
    val GreenMod = Color(0xFF8BC34A)
    val RedHigh = Color(0xFFE63B2E)
    val InfoBg = Color(0xFFEEF2F8)
    val GreenBadge = Color(0xFFE8F5E9)
    val GreenBadgeBorder = Color(0xFF2E7D32)
    val GreenBadgeText = Color(0xFF1B5E20)
}

/**
 * Zone statistics for capteurs section.
 * Values are already in kA (divided by 1000).
 */
data class ZoneStats(
    val count: Int,
    val avgKa: Double,
    val medianKa: Double,
    val maxKa: Double,
    val avgSensors: Double = 0.0,
)

/**
 * Nsg Certificate — Strike Radar.
 * Displays the annual ground flash density (Nsg) for a site.
 * Layout aligned with the validated PDF template (preview_cert_nsg.html).
 *
 * Terminology: Nsg (not Ng) — IEC 62858:2019
 * Network: GLD360+ · IEC 62305-2:2024 · IEC 62858:2019
 */
@Suppress("LongMethod")
@Composable
fun CertNsgScreen(
    siteName: String,
    nsg12Months: Double,
    analysisPeriod: String = "",
    nsgUnitOverride: String? = null,
    shareManager: ShareManager,
    appModel: AppModel,
    projectUuid: String,
    latitude: Double,
    longitude: Double,
    zone1Stats: ZoneStats? = null,
    zone2Stats: ZoneStats? = null,
    modifier: Modifier = Modifier
) {
    // Localised unit (strings.xml), unless a caller forces its own label
    val nsgUnit = nsgUnitOverride ?: stringResource(Res.string.doc_nsg_unit)
    Column(
        modifier = modifier
            .fillMaxSize()
            .background(Colors.Background)
            .verticalScroll(rememberScrollState())
            .padding(16.dp)
    ) {
        // ── Header with title + share button ─────────────────────────────
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = stringResource(Res.string.cert_nsg_density_title),
                    fontSize = 18.sp,
                    fontWeight = FontWeight.Bold,
                    color = Colors.Heading
                )
                Text(
                    text = stringResource(Res.string.cert_nsg_measured_network),
                    fontSize = 13.sp,
                    color = Colors.Primary
                )
            }
            ShareButton(
                title = stringResource(Res.string.cert_nsg_share_title, siteName),
                shareContent = buildShareContent(siteName, nsg12Months, nsgUnit),
                shareManager = shareManager
            )
        }

        Spacer(Modifier.height(12.dp))

        // ── Unlimited Nsg certificates with a probe: shown in addition to the existing flow ──
        val creationVisible = rememberProbeCreationVisible(appModel)
        val probeAccess = rememberProbeAccess(appModel, latitude, longitude)
        if (creationVisible && probeAccess.loaded && probeAccess.needsPromo) {
            NsgProbePromo(onCreate = { openProbeCreation(appModel, trial = false) })
            Spacer(Modifier.height(12.dp))
        }
        // A Nsg certificate bought per unit / pack must never be blocked: see BLOCK_NSG_PDF_DURING_TRIAL
        val pdfLocked = BLOCK_NSG_PDF_DURING_TRIAL && probeAccess.pdfBlocked
        if (pdfLocked) {
            PdfBlockedNotice(Modifier.padding(bottom = 8.dp))
        }

        // ── PDF export button ────────────────────────────────────────────
        var showLangPicker by remember { mutableStateOf(false) }

        Button(
            modifier = Modifier.fillMaxWidth().height(48.dp),
            onClick = { showLangPicker = true },
            enabled = !pdfLocked,
            colors = ButtonDefaults.buttonColors(containerColor = Colors.Primary)
        ) {
            Text(
                text = Res.string.doc_export_pdf.localized(),
                color = Colors.OnPrimary,
                fontWeight = FontWeight.Bold
            )
        }

        if (showLangPicker) {
            val pdfShareTitle = stringResource(Res.string.cert_nsg_share_title, siteName)
        PdfLangPickerDialog(
                currentLang = PdfOutputLang.FR,
                onLangSelected = { lang ->
                    showLangPicker = false
                    val nowMillis = DateTime.now().unixMillisLong
                    val now = DateTime.now()
                    val project = Project(
                        uuid = projectUuid,
                        name = siteName,
                        latitude = latitude,
                        longitude = longitude
                    )
                    val model = CertNsgModel(
                        siteName = siteName,
                        nsg12Months = nsg12Months,
                        nsgUnit = nsgUnit
                    )
                    val genDate =
                        "${now.dayOfMonth.toString().padStart(2, '0')}/" +
                            "${now.month1.toString().padStart(2, '0')}/" +
                            "${now.yearInt}"
                    val z1Pdf = zone1Stats?.let {
                        PdfHtmlBuilder.ZoneStatsPdf(
                            count = it.count,
                            minKa = 0.0,
                            medianKa = it.medianKa,
                            avgKa = it.avgKa,
                            maxKa = it.maxKa
                        )
                    }
                    val z2Pdf = zone2Stats?.let {
                        PdfHtmlBuilder.ZoneStatsPdf(
                            count = it.count,
                            minKa = 0.0,
                            medianKa = it.medianKa,
                            avgKa = it.avgKa,
                            maxKa = it.maxKa
                        )
                    }
                    shareManager.shareHtmlAsPdf(
                        pdfShareTitle,
                        PdfHtmlBuilder.buildCertNsg(
                            project = project,
                            model = model,
                            lang = lang,
                            generatedDate = genDate,
                            zone1Stats = z1Pdf,
                            zone2Stats = z2Pdf
                        )
                    )
                    appModel.recordDocumentHistory(
                        DocumentHistoryItem(
                            id = "cert_nsg_client_${projectUuid}_$nowMillis",
                            type = DocumentHistoryType.CERT_NSG,
                            siteName = siteName,
                            latitude = latitude,
                            longitude = longitude,
                            createdAtSecondsUtc = nowMillis / 1000L,
                        )
                    )
                },
                onDismiss = { showLangPicker = false },
            )
        }

        Spacer(Modifier.height(16.dp))

        // ── Site name block (centered) ───────────────────────────────────
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = siteName,
                fontSize = 22.sp,
                fontWeight = FontWeight.Bold,
                color = Colors.Heading
            )
            Text(
                text = "${latitude.fmt(4)}° N · ${longitude.fmt(4)}° E",
                fontSize = 13.sp,
                color = Colors.Muted
            )
        }

        Spacer(Modifier.height(16.dp))

        // ── Map section ──────────────────────────────────────────────────
        NsgMapSection(
            modifier = Modifier.fillMaxWidth(),
            latitude = latitude,
            longitude = longitude,
            projectName = siteName
        )

        Spacer(Modifier.height(16.dp))

        // ── Nsg Hero card ────────────────────────────────────────────────
        SectionTitle(stringResource(Res.string.cert_nsg_density_section))
        NsgHeroCard(
            nsg12Months = nsg12Months,
            nsgUnit = nsgUnit,
            analysisPeriod = analysisPeriod
        )

        Spacer(Modifier.height(16.dp))

        // ── Barème comparatif ────────────────────────────────────────────
        SectionTitle(stringResource(Res.string.cert_nsg_comparison_section))
        BaremeComparatif(nsg12Months = nsg12Months, nsgUnit = nsgUnit)

        Spacer(Modifier.height(16.dp))

        // ── Activité foudre remarquable autour du site ────────────────
        SectionTitle(stringResource(Res.string.cert_nsg_notable_activity_title))
        if (zone1Stats != null || zone2Stats != null) {
            val periodLabel = if (analysisPeriod.isNotEmpty()) {
                stringResource(Res.string.cert_nsg_period_suffix, analysisPeriod)
            } else ""
            InfoBlock(
                text = stringResource(Res.string.cert_nsg_notable_values, periodLabel)
            )
            Spacer(Modifier.height(10.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                if (zone1Stats != null) {
                    ZoneCard(
                        modifier = Modifier.weight(1f),
                        title = stringResource(Res.string.cert_nsg_zone_0_1km),
                        stats = zone1Stats
                    )
                }
                if (zone2Stats != null) {
                    ZoneCard(
                        modifier = Modifier.weight(1f),
                        title = stringResource(Res.string.cert_nsg_zone_1_2km),
                        stats = zone2Stats
                    )
                }
            }
        } else {
            InfoBlock(
                text = stringResource(Res.string.cert_nsg_no_notable_impacts)
            )
        }
        Spacer(Modifier.height(16.dp))

        // ── Note méthodologique ──────────────────────────────────────────
        InfoBlock(
            text = stringResource(Res.string.cert_nsg_methodology)
        )

        Spacer(Modifier.height(12.dp))

        // ── Nsg vs Ng ────────────────────────────────────────────────────
        InfoBlock(
            title = stringResource(Res.string.cert_nsg_vs_ng_title),
            text = stringResource(Res.string.cert_nsg_vs_ng)
        )

        Spacer(Modifier.height(12.dp))

        // ── Normes ───────────────────────────────────────────────────────
        InfoBlock(
            title = stringResource(Res.string.cert_nsg_standards_title),
            text = stringResource(Res.string.cert_nsg_standards_text)
        )

        Spacer(Modifier.height(16.dp))
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// Sub-components
// ─────────────────────────────────────────────────────────────────────────────

@Composable
private fun SectionTitle(text: String) {
    Text(
        text = text.uppercase(),
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 12.dp),
        fontSize = 13.sp,
        fontWeight = FontWeight.Bold,
        color = Colors.Primary,
        letterSpacing = 1.sp
    )
}

@Composable
private fun NsgHeroCard(nsg12Months: Double, nsgUnit: String, analysisPeriod: String = "") {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = Colors.Surface),
        shape = RoundedCornerShape(12.dp),
        elevation = CardDefaults.cardElevation(2.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .background(
                    color = Colors.Divider,
                    shape = RoundedCornerShape(12.dp)
                )
                .padding(20.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = stringResource(Res.string.cert_nsg_measured_label),
                fontSize = 12.sp,
                color = Colors.Muted,
                letterSpacing = 1.sp
            )
            Spacer(Modifier.height(8.dp))
            Row(verticalAlignment = Alignment.Bottom) {
                Text(
                    text = nsg12Months.fmt(1),
                    fontSize = 48.sp,
                    fontWeight = FontWeight.Black,
                    color = Colors.Primary
                )
                Spacer(Modifier.width(8.dp))
                Text(
                    text = nsgUnit,
                    fontSize = 16.sp,
                    color = Colors.Muted,
                    modifier = Modifier.padding(bottom = 8.dp)
                )
            }
            Spacer(Modifier.height(6.dp))
            val periodSuffix = if (analysisPeriod.isNotEmpty()) " · $analysisPeriod" else ""
            Text(
                text = stringResource(Res.string.cert_nsg_zone_network, periodSuffix),
                fontSize = 13.sp,
                color = Colors.Muted
            )
        }
    }
}

@Composable
private fun BaremeComparatif(nsg12Months: Double, nsgUnit: String) {
    Column(modifier = Modifier.fillMaxWidth()) {
        BaremeRow(
            label = stringResource(Res.string.cert_nsg_level_low),
            range = "< 1 $nsgUnit",
            fraction = 0.25f,
            barColor = Colors.GreenLow
        )
        Spacer(Modifier.height(8.dp))
        BaremeRow(
            label = stringResource(Res.string.cert_nsg_level_moderate),
            range = "1 – 3 $nsgUnit",
            fraction = 0.45f,
            barColor = Colors.GreenMod
        )
        Spacer(Modifier.height(8.dp))
        BaremeRow(
            label = stringResource(Res.string.cert_nsg_your_site),
            range = "Nsg = ${nsg12Months.fmt(1)}",
            fraction = (nsg12Months / 4.0).coerceIn(0.1, 0.95).toFloat(),
            barColor = Colors.Primary,
            highlight = true
        )
        Spacer(Modifier.height(8.dp))
        BaremeRow(
            label = stringResource(Res.string.cert_nsg_level_high),
            range = "> 3 $nsgUnit",
            fraction = 1.0f,
            barColor = Colors.RedHigh
        )
    }
}

@Composable
private fun BaremeRow(
    label: String,
    range: String,
    fraction: Float,
    barColor: Color,
    highlight: Boolean = false
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = label,
            modifier = Modifier.width(110.dp),
            fontSize = 14.sp,
            fontWeight = if (highlight) FontWeight.Bold else FontWeight.Normal,
            color = if (highlight) Colors.Primary else Colors.Muted
        )
        Box(
            modifier = Modifier
                .weight(1f)
                .height(28.dp)
                .background(
                    color = Colors.Divider,
                    shape = RoundedCornerShape(6.dp)
                )
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth(fraction)
                    .height(28.dp)
                    .background(
                        color = barColor,
                        shape = RoundedCornerShape(6.dp)
                    )
                    .padding(start = 10.dp),
                contentAlignment = Alignment.CenterStart
            ) {
                Text(
                    text = range,
                    fontSize = 12.sp,
                    fontWeight = FontWeight.Bold,
                    color = Color.White
                )
            }
        }
    }
}

@Composable
private fun InfoBlock(
    text: String,
    title: String? = null
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = Colors.Divider),
        shape = RoundedCornerShape(8.dp),
        elevation = CardDefaults.cardElevation(0.dp)
    ) {
        Column(Modifier.padding(14.dp)) {
            if (title != null) {
                Text(
                    text = title,
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Bold,
                    color = Colors.Heading
                )
                Spacer(Modifier.height(6.dp))
            }
            Text(
                text = text,
                fontSize = 13.sp,
                color = Colors.Muted,
                lineHeight = 20.sp
            )
        }
    }
}

@Composable
private fun ZoneCard(
    modifier: Modifier = Modifier,
    title: String,
    stats: ZoneStats
) {
    Card(
        modifier = modifier,
        colors = CardDefaults.cardColors(containerColor = Colors.Background),
        shape = RoundedCornerShape(10.dp),
        elevation = CardDefaults.cardElevation(0.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(start = 4.dp)
                .background(Colors.Background)
        ) {
            // Left blue accent bar simulated via padding
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(14.dp)
            ) {
                Text(
                    text = title,
                    fontSize = 12.sp,
                    fontWeight = FontWeight.Bold,
                    color = Colors.Primary,
                    letterSpacing = 0.5.sp
                )
                Spacer(Modifier.height(10.dp))
                ZoneStatRow(stringResource(Res.string.cert_nsg_detected_impacts), stats.count.toString())
                ZoneStatRow(stringResource(Res.string.cert_nsg_median_intensity), "${stats.medianKa.fmt(1)} kA")
                ZoneStatRow(stringResource(Res.string.cert_nsg_avg_intensity), "${stats.avgKa.fmt(1)} kA")
                ZoneStatRow(stringResource(Res.string.cert_nsg_max_intensity), "${stats.maxKa.fmt(1)} kA")
                if (stats.avgSensors > 0) {
                    ZoneStatRow(stringResource(Res.string.cert_nsg_avg_sensors), stats.avgSensors.fmt(1))
                }
            }
        }
    }
}

@Composable
private fun ZoneStatRow(label: String, value: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 3.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = label,
            fontSize = 13.sp,
            color = Colors.Muted
        )
        Text(
            text = value,
            fontSize = 14.sp,
            fontWeight = FontWeight.Bold,
            color = Colors.Heading
        )
    }
}

private fun buildShareContent(
    siteName: String,
    nsg12Months: Double,
    nsgUnit: String
): String = """
Certificat Nsg — Strike Radar
Site: $siteName
Nsg 12 mois: ${nsg12Months.fmt(2)} $nsgUnit

Réseau GLD360+
IEC 62305-2:2024 · IEC 62858:2019
""".trimIndent()

/**
 * MapCompose map showing the study point with a quadrant cross (NW/NE/SW/SE).
 */
@Composable
private fun NsgMapSection(
    modifier: Modifier = Modifier,
    latitude: Double,
    longitude: Double,
    projectName: String
) {
    val googleApi = remember { GoogleProvider() }
    val tileStreamProvider = remember(googleApi) {
        TileStreamProvider { row, col, zoomLvl ->
            googleApi.getTile(row, col, zoomLvl)
        }
    }
    val center = remember { MapUtils.latLngToXY(latitude, longitude) }
    val density = LocalDensity.current
    val mapState = remember {
        val vpPx = with(density) { 360.dp.toPx() }
        val cosLat = cos(latitude * PI / 180.0)
        val xRange = 2.0 * 5.0 / (40075.0 * cosLat)
        MapState(
            levelCount = MAP_LEVEL_COUNT,
            fullWidth = MAP_FULL_SIZE,
            fullHeight = MAP_FULL_SIZE,
            tileSize = 256,
        ) {
            scroll(center.x, center.y)
        }.apply {
            scale = vpPx / (MAP_FULL_SIZE.toDouble() * xRange)
        }
    }
    LaunchedEffect(Unit) {
        try { googleApi.initialize() } catch (_: Throwable) { }
        try { mapState.addLayer(tileStreamProvider) } catch (_: Throwable) { }
        val centerLL = LatLng(latitude, longitude)
        try {
            val north = MapUtils.delta(centerLL, 6000, 0.0)
            val south = MapUtils.delta(centerLL, 6000, PI)
            mapState.addPath(
                id = "cross_ns", width = 2.dp, color = Colors.Primary
            ) {
                addPoints(listOf(
                    MapUtils.latLngToXY(north).toPair(),
                    MapUtils.latLngToXY(south).toPair()
                ))
            }
        } catch (_: Throwable) { }
        try {
            val east = MapUtils.delta(centerLL, 6000, PI / 2.0)
            val west = MapUtils.delta(centerLL, 6000, 3.0 * PI / 2.0)
            mapState.addPath(
                id = "cross_ew", width = 2.dp, color = Colors.Primary
            ) {
                addPoints(listOf(
                    MapUtils.latLngToXY(east).toPair(),
                    MapUtils.latLngToXY(west).toPair()
                ))
            }
        } catch (_: Throwable) { }
        try {
            mapState.addMarker("center", center.x, center.y) {
                Canvas(Modifier.size(24.dp)) {
                    val cx = size.width / 2
                    val cy = size.height / 2
                    drawCircle(Colors.Primary, radius = 12f, center = Offset(cx, cy))
                    drawCircle(Color.White, radius = 4f, center = Offset(cx, cy))
                }
            }
        } catch (_: Throwable) { }
        // Re-center after tiles & markers are loaded
        try { mapState.snapScrollTo(center.x, center.y) } catch (_: Throwable) { }
    }
    Card(
        modifier = modifier,
        colors = CardDefaults.cardColors(containerColor = Colors.Surface),
        shape = RoundedCornerShape(16.dp),
        elevation = CardDefaults.cardElevation(2.dp)
    ) {
        Column(Modifier.padding(16.dp)) {
            Text(
                text = stringResource(Res.string.cert_nsg_location_label),
                fontSize = 13.sp,
                fontWeight = FontWeight.Bold,
                color = Colors.Primary,
                letterSpacing = 1.sp
            )
            Spacer(Modifier.height(8.dp))
            FullscreenMapContainer(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(360.dp)
                    .clip(RoundedCornerShape(10.dp)),
                controls = { isFullscreen -> if (isFullscreen) MapZoomControls(mapState) },
            ) { isFullscreen ->
                MapUI(
                    modifier = Modifier.fillMaxSize(),
                    state = mapState,
                )
                // Transparent overlay to disable map gestures (inline only, the full screen map is interactive)
                if (!isFullscreen) {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .background(Color.Transparent)
                            .pointerInput(Unit) { /* consume all touch events */ }
                    )
                }
            }
            Spacer(Modifier.height(8.dp))
            Text(
                modifier = Modifier.align(Alignment.CenterHorizontally),
                text = projectName.ifBlank { "${latitude.fmt(4)}, ${longitude.fmt(4)}" },
                fontSize = 14.sp,
                fontWeight = FontWeight.Bold,
                color = Colors.Heading
            )
            Text(
                modifier = Modifier.align(Alignment.CenterHorizontally),
                text = "${latitude.fmt(4)}, ${longitude.fmt(4)}",
                fontSize = 12.sp,
                color = Colors.Muted
            )
        }
    }
}
